import React, { useEffect, useState } from "react";
import api, { inr } from "@/lib/api";
import { toast } from "sonner";
import { ArrowUpCircle, ArrowDownCircle } from "lucide-react";

export default function CashLog() {
  const [items, setItems] = useState([]);
  const [form, setForm] = useState({ direction: "in", amount: 0, reason: "" });

  const load = async () => setItems((await api.get("/cash-log")).data);
  useEffect(() => { load(); }, []);

  const submit = async (e) => {
    e.preventDefault();
    try { await api.post("/cash-log", form); setForm({ direction: "in", amount: 0, reason: "" }); load(); toast.success("Recorded"); }
    catch(e){ toast.error("Failed"); }
  };

  const total_in = items.filter(i=>i.direction==="in").reduce((a,b)=>a+Number(b.amount||0),0);
  const total_out = items.filter(i=>i.direction==="out").reduce((a,b)=>a+Number(b.amount||0),0);

  return (
    <div className="space-y-6">
      <div>
        <div className="label-tiny mb-1">Cash desk</div>
        <h1 className="font-display text-3xl tracking-tight">Cash Log</h1>
        <p className="text-sm text-[#757169] mt-1">Running record of cash movements.</p>
      </div>

      <div className="grid grid-cols-3 gap-4">
        <div className="card-surface p-4"><div className="label-tiny">In</div><div className="font-display text-2xl font-bold text-[#4A7258] mt-1">{inr(total_in)}</div></div>
        <div className="card-surface p-4"><div className="label-tiny">Out</div><div className="font-display text-2xl font-bold text-[#B83A3A] mt-1">{inr(total_out)}</div></div>
        <div className="card-surface p-4"><div className="label-tiny">Balance</div><div className="font-display text-2xl font-bold mt-1">{inr(total_in - total_out)}</div></div>
      </div>

      <form onSubmit={submit} className="card-surface p-5 grid grid-cols-1 md:grid-cols-5 gap-3">
        <select className="input-field" value={form.direction} onChange={e=>setForm({...form,direction:e.target.value})} data-testid="cash-direction">
          <option value="in">Cash In</option><option value="out">Cash Out</option>
        </select>
        <input type="number" step="0.01" required placeholder="Amount" className="input-field" value={form.amount} onChange={e=>setForm({...form,amount:Number(e.target.value)})} data-testid="cash-amount"/>
        <input className="input-field md:col-span-2" placeholder="Reason" value={form.reason} onChange={e=>setForm({...form,reason:e.target.value})}/>
        <button className="btn-primary" data-testid="cash-submit">Record</button>
      </form>

      <div className="card-surface overflow-x-auto">
        <table className="data-table">
          <thead><tr><th>Direction</th><th>Amount</th><th>Reason</th><th>By</th><th>When</th></tr></thead>
          <tbody>
            {items.length === 0 && <tr><td colSpan={5} className="p-6 text-center text-[#757169]">No entries yet.</td></tr>}
            {items.map(i => (
              <tr key={i.id}>
                <td>{i.direction === "in" ? <span className="text-[#4A7258] flex items-center gap-1"><ArrowUpCircle size={14}/> In</span> : <span className="text-[#B83A3A] flex items-center gap-1"><ArrowDownCircle size={14}/> Out</span>}</td>
                <td className="mono">{inr(i.amount)}</td>
                <td>{i.reason||"—"}</td>
                <td>{i.by||"—"}</td>
                <td className="mono text-xs">{i.created_at?.slice(0,16).replace("T"," ")}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
